import { Suspense, useEffect, useState } from 'react'
import { Outlet } from 'react-router-dom'

import { ContentSkeleton } from '@/components/lazy'
import { Navbar } from '@/components/navbar'
import { cn } from '@/lib/utils'
import * as Caching from '@/shared/utils/caching'

export function AppLayout(): JSX.Element {
  const [open, setOpen] = useState(true)

  useEffect(() => {
    async function getSidebarStatus() {
      const sidebarStatus = await Caching.get<boolean>('@sidebar')
      setOpen(sidebarStatus ?? true)
    }

    getSidebarStatus()
  }, [])

  return (
    <main className={cn('bg-white flex gap-2 h-screen overflow-hidden p-2')}>
      <Navbar
        opened={open}
        handleToggle={() => {
          Caching.save('@sidebar', !open)
          setOpen(!open)
        }}
        className="h-full"
      />

      <div
        className={cn(
          'w-full duration-[100ms]  overflow-y-auto',
          open && 'pl-0 duration-[350ms]',
        )}
      >
        <Suspense fallback={<ContentSkeleton />}>
          <Outlet />
        </Suspense>
      </div>
    </main>
  )
}
